<template>
  <div class="main">
    <!-- max="1" so a longer notice (e.g. plans.migrationNotice) and a routine
         one (e.g. "Operação realizada com sucesso") queue one after another
         instead of both being visible - and visually stretching each other's
         width, since .vue-notification-group sizes to its widest child
         (_general.scss) - at the same time. -->
    <Notifications position="bottom center" :max="1"/>
    <router-view/>
  </div>
</template>

<style lang="scss" scoped>
  @media (min-width: 992px) {
    .main {
      display:                          flex;
      flex-direction:                   column;
      flex:                             1;
    }
  }
</style>

<script>
import { useUserStore } from '@/store/user'
const TAG = "[app]"
export default {
  name: 'layout',
  setup() {
  },
  data: () => ({
    collapse: false,
  }),
  mounted() {
    const userStore = useUserStore()
    const sessionInfo = userStore.sessionInfo

    if (sessionInfo && sessionInfo.currentClinic) {
      this.$i18n.locale = sessionInfo.currentClinic.locale.toLowerCase();
      console.log("[app] setting locale (from clinic):", sessionInfo.currentClinic.locale)
    }

    this.$notificationService.enable() // BEWARE, do not move this from HERE! Magic, don't touch!

    const thePath = window.location.pathname
    const noRouteWasSpecified = thePath.length <= 1

    if (noRouteWasSpecified) {
     this.$authService.goToFirstPage(this)
    }
  },
  methods: {

  },
}

</script>
